module.exports = __webpack_public_path__ + "static/media/favicon-divino-amor.4822d0b0.ico";